const MS_PER_MINUTE = 60_000;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const DAYS_PER_WEEK = 7;

export const formatRelativeTime = (input: string | Date, now: Date = new Date()): string => {
    const date = input instanceof Date ? input : new Date(input);
    const diffMs = now.getTime() - date.getTime();
    const minutes = Math.floor(diffMs / MS_PER_MINUTE);
    if (minutes < 1) return 'just now';
    if (minutes < MINUTES_PER_HOUR) return `${minutes}m ago`;
    const hours = Math.floor(minutes / MINUTES_PER_HOUR);
    if (hours < HOURS_PER_DAY) return `${hours}h ago`;
    const days = Math.floor(hours / HOURS_PER_DAY);
    if (days === 1) return 'yesterday';
    if (days < DAYS_PER_WEEK) return `${days}d ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
